import { useNavigate, useLocation } from 'react-router-dom';
import { HiHome, HiChartBar, HiBriefcase, HiStar, HiUser } from 'react-icons/hi2';

/**
 * App-level mobile bottom navigation bar (fixed, 5 items).
 * Per wireframe wf-shared.jsx MobileTabBar.
 * This is NOT workspace tab selection — it's cross-page navigation.
 * Hidden on desktop (md+).
 */
export function MobileTabBar({ className = '' }) {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { key: 'home', label: 'Home', Icon: HiHome, path: '/' },
    { key: 'dash', label: 'Dashboard', Icon: HiChartBar, path: '/dashboard' },
    { key: 'workspace', label: 'Workspace', Icon: HiBriefcase, path: null },
    { key: 'signals', label: 'Signals', Icon: HiStar, path: null },
    { key: 'me', label: 'Me', Icon: HiUser, path: null },
  ];

  return (
    <div className={`fixed bottom-0 left-0 right-0 bg-slate-900 border-t border-slate-700 flex items-center justify-around px-2 py-1.5 z-50 ${className}`}>
      {items.map(item => {
        const isActive = item.key === 'workspace'
          ? location.pathname.startsWith('/workspace')
          : item.path && location.pathname === item.path;

        return (
          <button
            key={item.key}
            onClick={() => item.path && navigate(item.path)}
            disabled={!item.path && item.key !== 'workspace'}
            className={`flex flex-col items-center gap-0.5 min-w-[60px] min-h-[48px] justify-center transition-colors ${
              isActive ? 'text-white' : 'text-slate-500'
            } ${!item.path && item.key !== 'workspace' ? 'opacity-30' : ''}`}
          >
            <span className={`leading-none ${isActive ? 'bg-slate-700 rounded-full p-1.5' : 'p-1.5'}`}>
              <item.Icon className="w-5 h-5 text-cyan-400" />
            </span>
            <span className={`text-[9px] ${isActive ? 'font-bold' : ''}`}>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
}
